 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!--Full width header End-->
<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Balaji Sevasamithi</h1>
      <ul>
        <li><a class="active" href="/">Home</a></li>

        <li>Balaji Sevasamithi</li>
      </ul>
    </div>
  </div>

  <section class="events-section pt-80 pb-80">
    <div class="container">
      <div class="row align-items-center">

        <!-- Left Image -->
        <div class="col-lg-4 col-md-5 text-center">
          <img src="assets/college/Balaji-Seva-Samiti.png" alt="Balaji Seva Samithi" class="img-fluid mb-3">

          <hr style="width: 120px; margin: auto;">
        </div>

        <!-- Right Content -->
        <div class="col-lg-8 col-md-7">

          <h1 class="text-warning fw-bold mb-3" style="font-style: italic; letter-spacing: 1px;">
            BALAJI SEVASAMITHI
          </h1>

          <p>
            A brainchild of Sri Balaji Educational Society, Chairman Sri Kishore Palle,
            Balaji Seva Samithi is setup as activity wing under Palle Uma Memorial Trust,
            this service is setup with a motto to serve the society.
          </p>

          <p>
            We firmly believe in the potential of a student and we equally believe in
            possibility of Transformation. Our Society has over 18000 students and
            majority of them would like the idea of lending a hand to help others
            and change lives for the betterment.
          </p>

        </div>

      </div>

      <!-- Bottom Paragraph -->
      <div class="row mt-4">
        <div class="col-lg-12">

          <p>
            With sheer numbers and volume of students, SBES believes that we can
            bring about change in all aspects of society while instilling great
            values and even greater satisfaction for all of our students.
            Through Balaji Seva Samithi, students can sign up to become a
            volunteer as a value-added member who will spend one hour in every
            month to participate in programs run by the Seva Samithi.
            This is completely voluntary and we are absolutely thrilled to
            announce that we have over 80% student turnout for these events.
          </p>

          <p>
            Thanks to all students and staff who volunteer for Balaji Seva Samithi,
            we are on the right track and path to create a better future and
            absolutely best opportunities for the nearby villages in the
            district of Anantapur and society.
          </p>

        </div>
      </div>

    </div>
  </section>
  <section class="events-section pt-80 pb-80">
    <div class="container">

      <!-- Title -->
      <div class="text-center mb-5">
        <h2 class="fw-bold text-warning">Balaji Sevasamithi Latest Events</h2>
      </div>

      <div class="row">

        <!-- Event 1 -->
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="card border-0 shadow-sm h-100">

            <img src="assets/college/Eyetesting.jpg" class="card-img-top" alt="Eye Camp">

            <div class="card-body">
              <h3 class="text-warning fw-bold">Two Days Eye<br /> Testing Camp</h3>

              <p>
                On the occasion of Smt.Uma's jayanthi celebrations,
                BSS conducted a 2-day eye testing camp on 16,17 Aug 2019.
              </p>

              <a href="#" class="text-warning fw-bold">View Details</a>
            </div>

          </div>
        </div>


        <!-- Event 2 -->
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="card border-0 shadow-sm h-100">

            <img src="assets/college/Blooddonation.jpg" class="card-img-top" alt="Blood Donation Camp">

            <div class="card-body">
              <h3 class="text-warning fw-bold">One Day Blood Donation Camp</h3>

              <p>
                On this occasion Dr.Palle Raghunatha Reddy Garu & Family
                distributed provisions to old age and orphanage children's home.
              </p>

              <a href="#" class="text-warning fw-bold">View Details</a>
            </div>

          </div>
        </div>


        <!-- Event 3 -->
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="card border-0 shadow-sm h-100">

            <img src="assets/college/Orphangehome.jpg" class="card-img-top" alt="Orphanage Visit">

            <div class="card-body">
              <h3 class="text-warning fw-bold">Rainbow childrens orphanage home</h3>

              <p>
                Groceries donation to the orphanage.
                Smt. Palle Uma Memorial Trust visited Rainbow children's orphanage home.
              </p>

              <a href="#" class="text-warning fw-bold">View Details</a>
            </div>

          </div>
        </div>

      </div>

    </div>
  </section>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
